module.exports = __webpack_public_path__ + "static/img/10.d286dc8.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/VascularSystem/Meeting584/images/10.png
// module id = OCxg
// module chunks = 4